import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IRawComponent } from 'projects/common/src/app/interfaces/remote-models';
import {
  UpdateChangeView,
  UpdateChangeViewButtonIcon,
  UpdateShowTable,
  UpdateTitleDashboard,
  UpdateIsTitleDashboard,
} from './dashboard.actions';

export interface IDashboadModel {
  isChangeView: boolean;
  isShowTable: boolean;
  buttonIcon: string;
  title: string;
  isTitleDashboard: boolean;
  rawComponent: IRawComponent;
}
@State<IDashboadModel>({
  name: 'dashboard',
  defaults: {
    buttonIcon: 'panel-view-icon',
    title: '',
    isTitleDashboard: false,
    isChangeView: false,
    isShowTable: false,
    rawComponent: {
      componentId: null,
      name: '',
      appId: null,
      orderElement: null,
      description: '',
      type: '',
      icon: '',
      componentType: null,
      presentationType: null,
      isEnabled: false,
      objCode: '',
      hasDownload: false,
      hasTable: false,
      hasChangeView: false,
      visibleName: '',
    },
  },
})
@Injectable()
export class DashboardState {
  constructor() {}
  @Selector()
  public static getButtonIcon(state: IDashboadModel): string {
    return state.buttonIcon;
  }
  @Selector()
  public static getIsChangeView(state: IDashboadModel): boolean {
    return state.isChangeView;
  }
  @Selector()
  public static getIsShowTable(state: IDashboadModel): IDashboadModel {
    return state;
  }
  @Selector()
  public static getIsTitleDashboard(state: IDashboadModel): boolean {
    return state.isTitleDashboard;
  }
  @Selector()
  public static getTitleDashboard(state: IDashboadModel): string {
    return state.title;
  }
  @Action(UpdateTitleDashboard)
  updateTitleDashboard({ getState, setState }: StateContext<IDashboadModel>, { payload }: UpdateTitleDashboard): void {
    const state = getState();
    setState({
      ...state,
      title: payload,
    });
  }
  @Action(UpdateIsTitleDashboard)
  updateIsTitleDashboard({ getState, setState }: StateContext<IDashboadModel>, { payload }: UpdateIsTitleDashboard): void {
    const state = getState();
    setState({
      ...state,
      isTitleDashboard: payload,
    });
  }
  @Action(UpdateChangeViewButtonIcon)
  updateChangeViewButtonIcon({ getState, setState }: StateContext<IDashboadModel>, { payload }: UpdateChangeViewButtonIcon): void {
    const state = getState();
    setState({
      ...state,
      buttonIcon: payload,
    });
  }
  @Action(UpdateChangeView)
  updateChangeView({ getState, setState }: StateContext<IDashboadModel>, { payload }: UpdateChangeView): void {
    const state = getState();
    setState({
      ...state,
      isChangeView: payload,
    });
  }
  @Action(UpdateShowTable)
  updateShowTable({ getState, setState }: StateContext<IDashboadModel>, { payload, switcher }: UpdateShowTable): void {
    const state = getState();
    setState({
      ...state,
      rawComponent: payload,
      isShowTable: switcher,
    });
  }
}
